module.exports = __webpack_public_path__ + "static/media/MGM_LOGO.a1a313ed.png";